import { Switch, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import { checkPermission } from './utils/Helpers';
import { AccessDenied } from './components/shared/AccessDenied/AccessDenied';
import { NotFound } from './components/shared/NotFound/NotFound';
import { routes } from './config/routes';
import { WebAppAccess } from './components/shared/AccessDenied/WebAppAccess';
import useToken from './hooks/useToken';
import { noOneHasPermission } from './userActivityWorker/helper';
import { isRingCentralEnabled } from './components/shared/Topbar/components/ringCentral/ringCentralConfig';

const hasRingCentralRouteAccess = route =>
  route.identifier !== 'call_history' || isRingCentralEnabled();

const hasRouteAccess = (route, permissionList) => {
  if (route.identifier === 'call_history') {
    return isRingCentralEnabled();
  }
  return (
    checkPermission(route?.permissions, route.title, permissionList) &&
    hasRingCentralRouteAccess(route)
  );
};

export const Routes = ({ webPermission }) => {
  const { accessToken, logout } = useToken();
  const permissionsListReducer = useSelector(state => state.permissionsList);

  const { permissionList, isLoading } = useSelector(
    state => state.permissionsList
  );
  const tenantMapping = permissionsListReducer?.tenantMapping;
  const [clientDetailsVersion, setClientDetailsVersion] = useState(0);

  useEffect(() => {
    const onClientDetailsUpdated = () =>
      setClientDetailsVersion(version => version + 1);
    window.addEventListener(
      'pf:client-details-updated',
      onClientDetailsUpdated
    );
    return () =>
      window.removeEventListener(
        'pf:client-details-updated',
        onClientDetailsUpdated
      );
  }, []);

  useEffect(() => {
    const client =
      Array.isArray(tenantMapping) &&
      tenantMapping?.length > 0 &&
      tenantMapping?.find(
        item => item?.client_name === localStorage.getItem('client_name')
      );
    const isPermission = client?.hasWebPermission ?? false;
    if (isPermission === false) {
      localStorage.setItem('webPermission', 'false');
    }
  }, [tenantMapping]);

  if (
    noOneHasPermission(tenantMapping) &&
    tenantMapping?.length > 0 &&
    accessToken
  ) {
    logout();
  }

  return (
    <>
      {!isLoading && (
        <Switch key={clientDetailsVersion}>
          {routes.map((route, index) =>
            route?.permissions ? (
              hasRouteAccess(route, permissionList) ? (
                !webPermission ? (
                  <Route
                    key={index}
                    path={route.path}
                    exact={true}
                    render={props => (
                      <route.component
                        {...props}
                        identifier={route.identifier}
                      />
                    )}
                  />
                ) : (
                  <Route
                    key={index}
                    path={route.path}
                    exact={true}
                    component={WebAppAccess}
                  />
                )
              ) : (
                <Route
                  key={`access-denied-${route.path}`}
                  path={route.path}
                  exact={true}
                  component={AccessDenied}
                />
              )
            ) : (
              <Route
                key={index}
                path={route.path}
                exact={true}
                render={props => (
                  <route.component {...props} identifier={route.identifier} />
                )}
              />
            )
          )}
          <Route path="*" exact={true} component={NotFound} />
        </Switch>
      )}
    </>
  );
};
